<div class="flex justify-end mr-[53px] mt-[30px]">
  <button (click)="handleClose()" class="close-button mr-[7px]">Close</button>
  <button
    class="secondary-button mr-[7px]"
    (click)="handleEdit(projectBriefData?.id)"
  >
    Edit
  </button>
  <button
    (click)="openDialog()"
    class="secondary-button mr-[7px] flex items-center flex-shrink-0"
  >
    Print
  </button>
  <button
    *ngIf="projectBriefData?.stage_two_completion_percentage === 0"
    (click)="handlePlanCreate()"
    class="print-button mr-[7px] !text-center"
    style="padding: 14px 24px;"
  >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_5810_47932)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
            fill="#E76B3F"
          />
          <path
            d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_5810_47932">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Create Project Plan
    </button>
    <button 
    class="print-button" 
    (click)="handleProjectStage1Approval()"   
    [ngClass]="{
      '!bg-[#197741] !border-[#197741]': isStageOneSendForApproval && approvalDetails.length > 0 && approvalDetails[0]?.parentStatus === 'approved',
      '!bg-[#ff0000] !border-[#ff0000]': approvalDetails.length > 0 && approvalDetails[0]?.parentStatus === 'rejected',
    }"
    
  >     
    <span>{{
      isStageOneSendForApproval ? "Approval Status" : "Send For Approval"
    }}</span>
  </button>
</div>
<app-stage1viewmode
  (projectBriefEmitter)="addProjectBriefData($event)"
></app-stage1viewmode>
<div id="plan">
  <app-stage2viewmode
    *ngIf="projectBriefData?.stage_two_completion_percentage > 0"
    (projectPlanEmitter)="addProjectPlanData($event)"
    (editStage2)="handlePlanEdit()"
  ></app-stage2viewmode>
</div>
<ng-template #dialogTemplate class="w-[100%] h-[100%]">
  <app-project-print-preview
    [projectBriefData]="projectBriefData"
    [projectPlanResponsibilityData]="projectPlanResponsibilityData"
    [projectPlanRiskRegisterData]="projectPlanRiskRegisterData"
  ></app-project-print-preview>
</ng-template>

<ng-container *ngIf="createPlan || isProjectOpen">
  <app-project-wrapper></app-project-wrapper>
</ng-container>
